$('.js-popup_open').on('touchstart click', function(event){
    event.preventDefault();
    $('.js-popup').addClass('lesmonts__product-size__popup__back--open');
    $('body').addClass('body-noscroll-class');
});

// close popup
$('.js-popup').on('touchstart click', function(event){
    if( $(event.target).is('.js-popup_close') || $(event.target).is('.js-popup') || $(event.target).parents('.js-popup_close').length > 0) {
        event.preventDefault();
        $(this).removeClass('lesmonts__product-size__popup__back--open');
        $('body').removeClass('body-noscroll-class');
    }
});

//close popup when clicking the esc keyboard button
$(document).keyup(function(event){
    if(event.which=='27'){
        $('.js-popup').removeClass('lesmonts__product-size__popup__back--open');
        $('body').removeClass('body-noscroll-class');
    }
});